import { SortDirection } from "react-virtualized"
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";

export const sortableHeaderRenderer = ({ label, dataKey, sortBy, sortDirection }) => {
    const isKeySorted = dataKey === sortBy;
    return (
        <span
            style={{ cursor: 'pointer' }}
        >
            {label} {(isKeySorted && sortDirection === SortDirection.ASC) ? <FaSortUp size={24} style={{position: 'relative', bottom: '-5px'}}/> : (isKeySorted && sortDirection === SortDirection.DESC) ? <FaSortDown size={24} style={{position: 'relative', bottom: '7px'}}/> : <FaSort size={14} style={{position: 'relative', bottom: '2px'}}/>}
        </span>
    );
};